<template>
  <div class='opc-monthly-price' tabindex='-1' :aria-label='ariaPriceOfMonthForLabel(plan)'>
    <span v-for='(value, key, index) in getPriceOfMonth(plan.amount, plan.billing_cycle, {forceDiff: true})'
          :key='index'
          :class="[`opc-monthly-price__${key}`, useSmallSize(value) ? 'opc-product-price-container__small' : '']"
          :style="value.symbol && value.place === 'end' ? { order: 1 } : {}"
          aria-hidden='true'
    >
      {{ value.symbol ? value.symbol : value }}
    </span>
    <p class='opc-monthly-price__text'
          v-html='getMergedBilledText(plan.billing_cycle, plan.amount)'></p>
  </div>
</template>
<script>
import discountedMonthPrice from '@/common/mixin/discounted-month-price';

export default {
  mixins: [discountedMonthPrice],
  props: {
    plan: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style lang='scss'>
.opc-monthly-price {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin: 0 0 2px;
  color: #00053D;

  &__currency {
    color: #00053D;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
  }

  &__integer {
    color: #00053D;
    font-weight: 600;
    font-size: 32px;
    line-height: 38.4px;
  }

  &__decimal {
    color: #00053D;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
  }

  &__text {
    color: #515079;
    font-size: 12px;
    font-style: normal;
    font-weight: 450;
    line-height: 120%;
    align-self: self-end;
  }

}
</style>
